import * as React from "react";

interface IEasonThinkProps {
  isShowEasonThink: boolean;
  handleClick: () => void;
}

interface IEasonThinkState {
  backgroundColor: string;
}

class EasonThink extends React.Component<IEasonThinkProps, IEasonThinkState> {
  constructor(props: IEasonThinkProps) {
    super(props);
    this.state = {
      backgroundColor: "#F17752"
    };
  }

  public render() {
    return (
      <a
        onClick={this.props.handleClick}
        onMouseEnter={this.changeBackgroundColor.bind(this, "#5D87C0")}
        onMouseLeave={this.changeBackgroundColor.bind(this, "#F17752")}
      >
        <svg
          className={`eason-think ${this.props.isShowEasonThink ? "show" : ""}`}
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 142.823 48.002"
        >
          <g>
            <g>
              <path
                fill={this.state.backgroundColor}
                d="M0.315,2.952h11.328v3.552H4.612v3.313h5.977v3.601H4.612v3.792h7.297v3.601H0.315V2.952z"
              />
              <path
                fill={this.state.backgroundColor}
                d="M14.499,16.993c0-2.88,2.256-4.44,7.584-5.017c-0.096-1.104-0.672-1.752-2.064-1.752
				c-1.08,0-2.207,0.432-3.576,1.2l-1.488-2.809c1.801-1.08,3.746-1.8,5.881-1.8c3.529,0,5.521,1.968,5.521,6.24v7.753h-3.48
				l-0.313-1.368h-0.096c-1.129,1.008-2.4,1.704-3.912,1.704C16.034,21.146,14.499,19.273,14.499,16.993z M22.083,16.753v-2.184
				c-2.664,0.359-3.527,1.128-3.527,2.088c0,0.792,0.576,1.176,1.463,1.176C20.884,17.833,21.46,17.425,22.083,16.753z"
              />
              <path
                fill={this.state.backgroundColor}
                d="M28.466,19.226l1.896-2.664c1.248,0.96,2.377,1.439,3.457,1.439c1.127,0,1.607-0.407,1.607-1.08
				c0-0.815-1.32-1.2-2.713-1.752c-1.631-0.647-3.551-1.752-3.551-4.008c0-2.593,2.111-4.345,5.279-4.345
				c2.16,0,3.697,0.864,4.896,1.752l-1.92,2.544c-0.959-0.672-1.92-1.151-2.832-1.151c-0.961,0-1.439,0.336-1.439,0.983
				c0,0.816,1.248,1.129,2.664,1.633c1.703,0.647,3.6,1.632,3.6,4.104c0,2.52-1.969,4.464-5.688,4.464
				C31.946,21.146,29.835,20.378,28.466,19.226z"
              />
              <path
                fill={this.state.backgroundColor}
                d="M41.114,13.993c0-4.536,3.217-7.177,6.697-7.177c3.455,0,6.672,2.641,6.672,7.177
				c0,4.512-3.217,7.152-6.672,7.152C44.331,21.146,41.114,18.505,41.114,13.993z M50.114,13.993c0-2.28-0.719-3.721-2.303-3.721
				c-1.609,0-2.328,1.44-2.328,3.721c0,2.256,0.719,3.696,2.328,3.696C49.396,17.689,50.114,16.249,50.114,13.993z"
              />
              <path
                fill={this.state.backgroundColor}
                d="M57.169,7.152h3.48l0.289,1.704h0.096c1.129-1.104,2.52-2.04,4.369-2.04
				c2.975,0,4.248,2.136,4.248,5.544v8.449h-4.273v-7.921c0-1.872-0.504-2.424-1.584-2.424c-0.959,0-1.535,0.432-2.375,1.224v9.121
				h-4.25V7.152z"
              />
              <path
                fill={this.state.backgroundColor}
                d="M77.835,15.313c-0.504,0.096-1.08,0.191-1.656,0.239v0.984h1.008v2.064h-1.008v0.647l1.391-0.096
				l0.025,2.256c-1.896,0.192-3.793,0.36-5.449,0.505l-0.215-2.425l1.752-0.096v-0.792h-1.057v-2.064h1.057v-0.816
				c-0.385,0-0.77,0-1.129-0.023c-0.072-0.504-0.313-1.296-0.553-1.849c1.584-0.096,3.529-0.264,4.801-0.576L77.835,15.313z
				 M92.476,21.89c-0.072-0.408-0.191-0.888-0.385-1.393c-0.359,1.776-1.127,2.257-2.664,2.257h-2.16
				c-2.52,0-3.047-0.792-3.047-3.168v-0.48c-0.338,1.056-0.77,2.16-1.25,3l-1.848-1.248v2.208h-3.168V12.793
				c-1.992,0.144-3.936,0.264-5.568,0.384l-0.264-2.664l1.031-0.048V3.888h-0.959V1.176h9.744v2.712h-0.816v16.058
				c0.529-1.008,1.008-2.28,1.273-3.36l1.824,0.769v-0.816h1.992c-0.145-0.168-0.289-0.336-0.434-0.479l1.32-0.696h-5.328v-2.904
				h12.865v2.904h-6.193c0.889,0.912,1.777,2.04,2.209,2.856l-0.672,0.384c0.408,0.264,1.031,0.504,1.584,0.672
				c-0.359-0.744-0.816-1.488-1.32-2.112l2.328-1.008c1.176,1.368,2.137,3.264,2.424,4.632L92.476,21.89z M76.226,3.888v0.721h1.729
				V3.888H76.226z M76.226,7.368h1.729v-0.72h-1.729V7.368z M77.954,10.249V9.408h-1.729v0.912L77.954,10.249z M86.522,4.561h-4.344
				V1.896h4.68c0.049-0.504,0.096-0.983,0.121-1.439l3.023,0.191c-0.047,0.408-0.096,0.816-0.145,1.248H94.3v2.665h-4.824
				l-0.145,0.863h4.705v6.313H82.37V5.424h4.033L86.522,4.561z M85.778,7.849h-0.912v1.464h0.912V7.849z M89.091,20.233
				c0.457,0,0.576-0.216,0.648-1.488l-1.393,0.816c-0.264-0.552-0.744-1.248-1.248-1.92v1.92c0,0.6,0.072,0.672,0.625,0.672H89.091z
				 M88.563,7.849h-0.912v1.464h0.912V7.849z M90.435,9.313h0.961V7.849h-0.961V9.313z"
              />
              <path
                fill={this.state.backgroundColor}
                d="M114.532,19.609c0.672,0,0.791-0.384,0.912-2.76c0.695,0.552,2.184,1.104,3.119,1.319
				c-0.359,3.625-1.248,4.608-3.695,4.608h-2.666c-3.119,0-3.84-1.031-3.84-4.032v-3.864h-2.711
				c-0.266,4.44-1.297,6.984-7.922,8.209c-0.264-0.888-1.127-2.28-1.799-3c5.375-0.769,5.975-2.16,6.145-5.209h-5.641v-3.264h21.625
				v3.264h-6.145v3.841c0,0.815,0.096,0.888,0.84,0.888H114.532z M100.251,8.977h-3.48V2.592h8.545
				c-0.193-0.552-0.408-1.08-0.625-1.56L108.29,0c0.434,0.768,0.865,1.752,1.152,2.592h8.186v6.385h-3.648V5.929h-13.729V8.977z
				 M101.042,10.417V7.225h12.121v3.192H101.042z"
              />
              <path
                fill={this.state.backgroundColor}
                d="M140.716,13.633c-0.84,2.16-2.088,3.912-3.648,5.305c1.561,0.552,3.289,0.96,5.232,1.224
				c-0.721,0.721-1.633,2.137-2.064,3.024c-2.447-0.456-4.584-1.152-6.408-2.088c-1.896,0.96-4.08,1.656-6.434,2.136
				c-0.287-0.792-0.936-2.016-1.488-2.76v2.641h-3.287v-9.313c-0.359,0.36-0.744,0.696-1.104,1.008
				c-0.289-0.743-1.201-2.52-1.777-3.288c1.848-1.416,3.77-3.648,4.873-5.904l3.072,1.104c-0.504,1.008-1.104,2.04-1.777,3.023
				v10.537c1.729-0.264,3.361-0.672,4.826-1.224c-0.313-0.265-0.625-0.553-0.912-0.84c-0.457,0.407-0.912,0.792-1.393,1.128
				c-0.457-0.648-1.609-1.944-2.256-2.545c0.527-0.336,1.055-0.695,1.535-1.104c-0.48-0.72-0.936-1.488-1.344-2.305l2.832-0.888
				c0.191,0.36,0.385,0.72,0.625,1.056c0.455-0.575,0.887-1.2,1.271-1.848c-2.113,0.192-2.785,0.312-3.336,0.528
				c-0.145-0.624-0.648-2.257-1.008-3.145c0.887-0.145,1.584-0.504,2.736-1.152c0.359-0.191,0.959-0.528,1.703-0.984
				c-1.92,0.12-2.52,0.24-2.928,0.385c-0.191-0.696-0.721-2.353-1.104-3.265c0.527-0.12,1.031-0.408,1.631-0.792
				c0.625-0.384,2.473-1.632,3.697-3.072l3.504,1.512c-1.008,0.889-2.209,1.824-3.432,2.616l2.398-0.048
				c0.816-0.647,1.609-1.344,2.305-2.04l3.24,1.752c-2.088,1.801-4.488,3.408-6.889,4.753l3.602-0.192l-0.648-1.032l2.664-1.344
				c1.104,1.608,2.688,3.864,3.432,5.257l-2.855,1.607c-0.24-0.527-0.6-1.2-1.008-1.92l-3.938,0.288
				c-0.215,0.456-0.455,0.912-0.695,1.368h3.84l0.553-0.12L140.716,13.633z M127.323,1.488c-1.488,2.16-3.674,4.512-5.617,6.024
				c-0.408-0.696-1.248-1.921-1.801-2.545c1.609-1.176,3.434-3.168,4.346-4.68L127.323,1.488z M131.931,16.009
				c0.6,0.528,1.248,1.009,1.969,1.44c0.816-0.576,1.535-1.2,2.111-1.92h-3.695L131.931,16.009z"
              />
            </g>
          </g>
          <circle
            className="dot"
            fill={this.state.backgroundColor}
            cx="5.648"
            cy="42.355"
            r="5.648"
          />
          <circle
            className="dot"
            fill={this.state.backgroundColor}
            cx="31.953"
            cy="42.355"
            r="5.647"
          />
          <circle
            className="dot"
            fill={this.state.backgroundColor}
            cx="58.258"
            cy="42.355"
            r="5.647"
          />
          <circle
            className="dot"
            fill={this.state.backgroundColor}
            cx="84.564"
            cy="42.355"
            r="5.647"
          />
          <circle
            className="dot"
            fill={this.state.backgroundColor}
            cx="110.869"
            cy="42.355"
            r="5.647"
          />
          <circle
            className="dot"
            fill={this.state.backgroundColor}
            cx="137.176"
            cy="42.355"
            r="5.647"
          />
        </svg>
      </a>
    );
  }

  private changeBackgroundColor(color: string) {
    this.setState({ backgroundColor: color });
  }
}

export default EasonThink;



// WEBPACK FOOTER //
// ./src/adventureStory/components/EasonThink.tsx